export const sanitizeBrlValue = (event: { target: { value: string } }) => {
  let value = event.target.value.replace(/\D/g, "");
  if (value) {
    value = (Number.parseInt(value) / 100)
      .toFixed(2)
      .replace(".", ",")
      .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }
  return value;
};

export const normalSanatizerBRL = (value: number) => {
  return value
    .toFixed(2)
    .replace(".", ",")
    .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
};

//rebuild

const LOCAL_STORAGE_KEY = "investidor-sardinha-calculadora";

type SaveData = {
  [key: string]: Record<string, unknown>;
};
export function loadSavedCalculatorData(calculatorKey: string) {
  const savedData = localStorage.getItem(LOCAL_STORAGE_KEY);
  if (!savedData) return null;
  const parsedData = safeJsonParse(savedData);
  if (parsedData && typeof parsedData === "object") {
    const calculatorData = parsedData[calculatorKey];
    return calculatorData ?? null;
  }

  return null;
}

export function saveCalculatorData(
  calculatorKey: string,
  data: Record<string, unknown>,
) {
  const savedData = localStorage.getItem(LOCAL_STORAGE_KEY);
  let parsedData: SaveData = {};
  if (savedData) {
    parsedData = safeJsonParse(savedData) || {};
  }
  parsedData[calculatorKey] = data;
  localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(parsedData));

  if (window.WP_Data.user_email && window.pulseTracker) {
    window.pulseTracker.trackEvent(
      "calculating-" + calculatorKey,
      JSON.stringify(data),
      window.WP_Data.user_email,
    );
  }
}

function safeJsonParse(jsonString: string): SaveData | null {
  try {
    return JSON.parse(jsonString);
  } catch (error) {
    console.error("Error parsing JSON:", error);
    return null;
  }
}

export const CALCULATOR_USAGE_LIMIT = 10;

export function getCalculatorUsageFromToday(): number {
  const today = new Date().toISOString().split("T")[0];
  const usageData = localStorage.getItem("calculatorUsage");
  if (!usageData) {
    localStorage.setItem("calculatorUsage", JSON.stringify({}));
    return 0;
  }
  const usage = JSON.parse(usageData);
  if (!usage[today]) {
    usage[today] = 0;
    localStorage.setItem("calculatorUsage", JSON.stringify(usage));
    return 0;
  }
  return usage[today];
}

export function incrementCalculatorUsage() {
  const today = new Date().toISOString().split("T")[0];
  const usageData = localStorage.getItem("calculatorUsage");
  const usage = usageData ? JSON.parse(usageData) : {};
  usage[today] ??= 1;
  usage[today] += 1;
  localStorage.setItem("calculatorUsage", JSON.stringify(usage));
}

export function checkCalculatorUsageLimitAndRedirect(callBack: () => void) {
  if (
    !window.WP_Data?.is_user_logged_in &&
    getCalculatorUsageFromToday() >= CALCULATOR_USAGE_LIMIT
  ) {
    window.location.href = `/wp-login.php?redirect_to=${encodeURIComponent(
      window.location.href,
    )}&limit_exceeded=true`;

    return;
  }
  incrementCalculatorUsage();
  callBack();
}

export function removeMask(value: string) {
  return Number.parseFloat(value.replace(/[^0-9,-]+/g, "").replace(",", "."));
}
